import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { DaysLeft } from './DaysLeft';
import { ProgressBar } from './ProgressBar';
interface ProjectCardProps {
  title: string;
  thumbnailUrl: string;
  businessId: number;
  slugId?: string;
  /** 남은 날자수 */
  daysLeft: number;
  donationAmount: number;
  achievementRate: number;
  institution?: {
    id: number;
    logoUrl: string;
    name: string;
  };
  isEnded?: boolean;
  onProjectLinkClick?: () => void;
}
export const ProjectCard = t0 => {
  const $ = _c(46);
  const {
    title,
    thumbnailUrl,
    businessId,
    slugId,
    daysLeft,
    donationAmount,
    achievementRate,
    institution,
    isEnded,
    onProjectLinkClick
  } = t0;
  let t1;
  if ($[0] !== businessId || $[1] !== slugId) {
    t1 = DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
      id: slugId ?? businessId
    });
    $[0] = businessId;
    $[1] = slugId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== thumbnailUrl || $[4] !== title) {
    t2 = <Image fill={true} sizes={`${BREAKPOINTS.MOBILE} 100vw, ${BREAKPOINTS.TABLET} 50vw, 314px`} src={thumbnailUrl} alt={title} className="object-cover" />;
    $[3] = thumbnailUrl;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onProjectLinkClick || $[7] !== t1 || $[8] !== t2) {
    t3 = <CustomLink href={t1} aria-label={"\uC9C0\uC815\uAE30\uBD80\uC0AC\uC5C5 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} onClick={onProjectLinkClick} className="relative block aspect-[335/180] w-full">{t2}</CustomLink>;
    $[6] = onProjectLinkClick;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = !institution;
  let t5;
  if ($[10] !== t4) {
    t5 = cn("mb-8 flex items-center justify-between", {
      "justify-end": t4
    });
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== institution) {
    t6 = institution ? <CustomLink href={DONATION_ROUTES.HOMETOWNS_DETAIL.withSearchParams({
      dynamicPath: {
        id: institution.id
      },
      searchParams: {
        tab: "projects"
      }
    })} aria-label={"\uC9C0\uC790\uCCB4 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="flex items-center gap-4"><Image className="size-20 rounded-pill border border-Gray-300" src={institution.logoUrl} alt={institution.name} width={20} height={20} /><span className="mt-1 font-600 text-Gray-600 typo-caption1">{institution.name}</span><SvgChevronright className="size-12 text-Gray-600" /></CustomLink> : null;
    $[12] = institution;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== daysLeft || $[15] !== isEnded) {
    t7 = <DaysLeft value={daysLeft} isEnded={isEnded} />;
    $[14] = daysLeft;
    $[15] = isEnded;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== businessId) {
    t9 = DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
      id: businessId
    });
    $[21] = businessId;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== onProjectLinkClick || $[24] !== t9 || $[25] !== title) {
    t10 = <CustomLink href={t9} aria-label={"\uC9C0\uC815\uAE30\uBD80\uC0AC\uC5C5 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="mb-16 line-clamp-2 w-fit overflow-hidden text-ellipsis font-600 text-Gray-black typo-body3" onClick={onProjectLinkClick}>{title}</CustomLink>;
    $[23] = onProjectLinkClick;
    $[24] = t9;
    $[25] = title;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== achievementRate) {
    t11 = <ProgressBar progress={achievementRate} />;
    $[27] = achievementRate;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== achievementRate) {
    t12 = <span className="text-R-500">{achievementRate}%</span>;
    $[29] = achievementRate;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== donationAmount) {
    t13 = donationAmount.toLocaleString();
    $[31] = donationAmount;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13) {
    t14 = <span className="text-Gray-black">{t13} 원</span>;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t14) {
    t15 = <div className="mt-10 flex h-30 items-center justify-between gap-2 font-700 typo-body3">{t12}{t14}</div>;
    $[35] = t12;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t15 || $[41] !== t8) {
    t16 = <div className="px-20 py-16">{t8}{t10}{t11}{t15}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t15;
    $[41] = t8;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t16 || $[44] !== t3) {
    t17 = <article className="overflow-hidden rounded-xlarge border border-Gray-300">{t3}{t16}</article>;
    $[43] = t16;
    $[44] = t3;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
};